exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mini-player[data-v-3c517b65]{position:relative;font-size:18px}.mini-player .on-air[data-v-3c517b65]{background:#fff;border:1px solid #fff;border-radius:2px;color:#000;height:28px;min-width:120px;right:40px;top:-2px;position:absolute;font-size:90%;display:flex;align-items:center;padding:2px 10px 0;white-space:nowrap}", ""]);

